/**
 * Allergen UI components.
 *
 * AllergenBadges       — inline badges for a product's allergen list
 * AllergenInfoDialog   — full EU-regulation allergen reference modal
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";
import { ALLERGEN_INFO } from "./MenuConstants";

export function AllergenBadges({ allergens }) {
  if (!allergens || allergens.length === 0) return null;
  return (
    <div className="flex gap-1 flex-wrap" data-testid="allergen-badges">
      {allergens.map(id => {
        const a = ALLERGEN_INFO[id];
        if (!a) return null;
        return (
          <span key={id} className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-md text-[10px] font-medium"
            style={{ backgroundColor: `${a.color}15`, color: a.color, border: `1px solid ${a.color}30` }}
            title={a.name} data-testid={`badge-allergen-${id}`}>
            <span className="text-xs">{a.icon}</span>{a.name}
          </span>
        );
      })}
    </div>
  );
}

export function AllergenInfoDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm bg-white" data-testid="allergen-info-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-amber-500" />
            Informacao de Alergenos
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          <p className="text-xs text-gray-500 mb-3">
            Em conformidade com o Regulamento (UE) No 1169/2011, informamos sobre os alergenos presentes nos nossos produtos.
          </p>
          <div className="grid grid-cols-2 gap-2">
            {Object.entries(ALLERGEN_INFO).map(([id, a]) => (
              <div key={id} className="flex items-center gap-2 px-2 py-1.5 rounded-lg bg-gray-50 text-xs">
                <span className="text-base">{a.icon}</span>
                <span className="text-gray-700 font-medium">{a.name}</span>
              </div>
            ))}
          </div>
          <p className="text-[10px] text-gray-400 mt-3">
            Consulte nosso pessoal para mais informacoes sobre ingredientes e possiveis vestigios de alergenos.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
